import { render } from "./AdminUserGameHistory.vue?vue&type=template&id=1e2e9558"
import script from "./AdminUserGameHistory.vue?vue&type=script&lang=js"
export * from "./AdminUserGameHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__